import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wellsACLFilter',
  pure:false
})

export class WellsACLFilterPipe implements PipeTransform {

  transform(value: any[], input: string, trigger: any): any[] {
    if (!value || !input) {
      return value;
    }
    input = input.toLowerCase();
    return value.filter(well => (well.fieldName != null ? well.fieldName.toLowerCase().indexOf(input) > -1: null) ||
      (well.wellName != null ? well.wellName.toLowerCase().indexOf(input) > -1 : null) ||
      (well.batteryName != null ? well.batteryName.toLowerCase().indexOf(input) > -1 : null) ||
      (well.api != null ? well.api.toLowerCase().indexOf(input) > -1 : null) ||
      (well.serialNumber != null ? well.serialNumber.toLowerCase().indexOf(input) > -1 : null))
  }
}
